import constants from "@/config/constants.json"
import { setNavigation } from "@/store/slices/appSlice"
import { store } from "@/store/store"

export const getStorageImagePath = (image) => {
	    if (!image) return undefined

	    let imageValue = image

	    if (typeof image === 'string') {
	        try {
	            const parsedImage = JSON.parse(image)
	            if (parsedImage?.file) {
	                imageValue = parsedImage
	            }
	        } catch {
	            imageValue = image
	        }
	    }

	    return `${constants?.hosts?.storage}${typeof imageValue === 'string' ? imageValue : imageValue?.file}`
}

export const getTypeAnimationSequence = (
    value?: string | null,
    delay = 700
): Array<string | number> => {
    if (!value) return []

    return value
        .split("|")
        .map((item) => item.trim())
        .filter(Boolean)
        .flatMap((item) => [item, delay])
}


export const navigateTo = (e,route) => {
    e.preventDefault()
    e.stopPropagation()
    store.dispatch(setNavigation(route))
}
